import throttle from 'lodash/throttle'

export default throttle
